<template>
  <v-card class="ui-module-card ui-module-fade-in-up pase-lista-shell" flat>
    <v-card-title class="d-flex justify-center align-center">
      <div class="text-h5 font-weight-bold">{{ tituloSeccion }}</div>
    </v-card-title>
    <v-card-text class="pase-lista-content">
      <v-container class="pa-0" fluid>
        <v-row>
          <v-col cols="12" class="d-flex justify-end">
            <div class="search-shell">
              <BaseInput
                v-model="search"
                class="search-input"
                label="Buscar personal asignado"
                append-icon="mdi-magnify"
                style="max-width: 340px"
              />
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-card class="ui-module-card ui-module-fade-in-up table-shell" color="primary" :loading="loading">
              <v-card-text class="table-content">
                <v-data-table
                  :headers="headers"
                  :items="filteredPersonal"
                  :items-per-page="20"
                  :footer-props="{ 'items-per-page-options': [20, 50, 100, 150], 'items-per-page-text': 'Filas por página' }"
                  class="transparent enlace-table ui-module-table"
                >
                  <template v-slot:[`item.nombreCompleto`]="{ item }">
                    <div class="person-name">{{ item.nombreCompleto }}</div>
                  </template>
                  <template v-slot:[`item.CUIP`]="{ item }">
                    <span class="person-meta">{{ item.CUIP || 'Sin datos' }}</span>
                  </template>
                  <template v-slot:[`item.puesto`]="{ item }">
                    <span class="person-meta">{{ item.puesto }}</span>
                  </template>
                  <template v-slot:[`item.dependencia`]="{ item }">
                    <span class="person-meta">{{ item.dependencia }}</span>
                  </template>
                  <template v-slot:[`item.opciones`]="{ item }">
                    <span class="actions-row-wrapper">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on" class="action-trigger">
                            <IconButton
                              class="action-btn"
                              variant="secondary"
                              icon="mdi-card-account-details-outline"
                              :elevation="8"
                              :to="{
                                name: 'enlace.expedientePersonalSection',
                                params: { id: item.id_personal },
                              }"
                            />
                          </span>
                        </template>
                        <span>Ver Expediente</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on" class="action-trigger">
                            <IconButton
                              class="action-btn"
                              variant="secondary"
                              icon="mdi-account-plus"
                              :elevation="8"
                              @click="openRegistroAsistenciaDialog(item)"
                            />
                          </span>
                        </template>
                        <span>Registrar Asistencia</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on" class="action-trigger">
                            <IconButton
                              :elevation="8"
                              class="action-btn"
                              variant="secondary"
                              icon="mdi-list-box-outline"
                              @click="openListadoAsistenciasDialog(item)"
                            />
                          </span>
                        </template>
                        <span>Listado de asistencias</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on" class="action-trigger">
                            <IconButton
                              elevation="8"
                              class="action-btn fatiga-btn"
                              variant="secondary"
                              icon="mdi-format-list-checks"
                              :to="{ name: 'enlace.fatigaEntregaRecepcion', query: { idPersonal: item.id_personal } }"
                            />
                          </span>
                        </template>
                        <span>Fatiga entrega/recepción</span>
                      </v-tooltip>
                    </span>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import BaseInput from '../base/BaseInput.vue'
import IconButton from '../base/IconButton.vue'
import { DIALOG_TYPES } from '@/plugins/dialog-types'

const ID_SEDE_SSC = 1

export default {
  components: {
    IconButton,
    BaseInput,
  },
  data() {
    return {
      headers: [
        { text: 'Nombre', value: 'nombreCompleto', width: '250px' },
        { text: 'CUIP', value: 'CUIP', width: '180px' },
        { text: 'Puesto', value: 'puesto', width: '150px' },
        { text: 'Dependencia', value: 'dependencia', width: '180px' },
        { text: 'Opciones', value: 'opciones', sortable: false, width: '200px' },
      ],
      loading: false,
      search: '',
      DIALOG_TYPES,
      personalData: [],
      idSede: null,
      idSubsede: null,
      tituloSeccion: 'Personal asignado a',
    }
  },
  computed: {
    ...mapGetters({
      idPersonal: 'getIdPersonal',
    }),

    filteredPersonal() {
      if (!this.search) return this.personalData

      const searchLower = this.search.toLowerCase()
      return this.personalData.filter((item) => {
        const nombreCompleto = (item.nombreCompleto || '').toLowerCase()
        const cuip = (item.CUIP || '').toLowerCase()
        const puesto = (item.puesto || '').toLowerCase()
        const dependencia = (item.dependencia || '').toLowerCase()
        const subsede = (item.Subsede || '').toLowerCase()

        return (
          nombreCompleto.includes(searchLower) ||
          cuip.includes(searchLower) ||
          puesto.includes(searchLower) ||
          dependencia.includes(searchLower) ||
          subsede.includes(searchLower)
        )
      })
    },

  },
  methods: {
    ...mapMutations('dialog', ['SET_DIALOG']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),
    ...mapActions('personal', ['fetchSedePersonal']),

    openRegistroAsistenciaDialog(item) {
      this.SET_DIALOG({
        ...this.DIALOG_TYPES.REGISTRAR_ASISTENCIA,
        props: {
          selectedPersonal: {
            ...item,
            idPersonal: item.id_personal,
          },
        },
      })
    },

    openListadoAsistenciasDialog(item) {
      this.SET_DIALOG({
        ...this.DIALOG_TYPES.LISTADO_DE_ASISTENCIAS,
        props: {
          selectedPersonal: {
            ...item,
            idPersonal: item.id_personal,
          },
        },
      })
    },

    async loadPersonalBySede() {
      this.loading = true
      try {
        const idSede = this.idSede

        let response = null

        if (idSede) {
          if (idSede === ID_SEDE_SSC && this.idSubsede) {
            response = await this.$store.dispatch('sede/fetchPersonalBySubSede', {
              pageNumber: 1,
              rowsOfPage: 150,
              idSubSede: this.idSubsede,
            })
            const subsedes = this.$store.getters['subsede/getSubsedes']
            const subsede = subsedes.find((s) => s.id === this.idSubsede)
            const nombreSubsede = subsede ? subsede.nombre || subsede.title || subsede.sede : null
            this.tituloSeccion = nombreSubsede ? `Personal asignado a ${nombreSubsede}` : 'Personal asignado a subsede'
          } else {
            response = await this.$store.dispatch('sede/fetchPersonalBySede', {
              pageNumber: 1,
              rowsOfPage: 150,
              idSede: idSede,
            })
            const sedes = this.$store.getters['sede/getSedes']
            const sede = sedes.find((s) => s.id === idSede)
            const nombreSede = sede ? sede.nombre || sede.title || sede.sede : null
            this.tituloSeccion = nombreSede ? `Personal asignado a ${nombreSede}` : 'Personal asignado a sede'
          }
        } else {
          this.SET_SNACKBAR_MESSAGE('No se encontró información de sede/subsede. Por favor, contacte al administrador.')
          this.personalData = []
          return
        }

        if (response && response.data && Array.isArray(response.data)) {
          this.personalData = response.data
        } else {
          this.personalData = []
          this.SET_SNACKBAR_MESSAGE('No se encontró personal para esta sede/subsede.')
        }
      } catch (error) {
        this.SET_SNACKBAR_MESSAGE('Error al cargar el personal. Por favor, intente nuevamente.')
        this.personalData = []
      } finally {
        this.loading = false
      }
    },
  },

  async created() {
    await this.$store.dispatch('sede/fetchSedes')
    const { idSede, idSubsede } = await this.fetchSedePersonal(this.idPersonal)
    this.idSede = idSede
    this.idSubsede = idSubsede
    if (idSede === ID_SEDE_SSC) {
      await this.$store.dispatch('subsede/fetchSubsedes')
    }
    await this.loadPersonalBySede()
  },
}
</script>

<style scoped>
.pase-lista-shell {
  background: transparent !important;
  border: 0 !important;
  box-shadow: none !important;
  backdrop-filter: none !important;
  -webkit-backdrop-filter: none !important;
  overflow: hidden;
}

::v-deep .pase-lista-shell.v-card {
  background: transparent !important;
  border: 0 !important;
  box-shadow: none !important;
  backdrop-filter: none !important;
  -webkit-backdrop-filter: none !important;
}

::v-deep .pase-lista-shell.v-card:hover {
  transform: none !important;
  box-shadow: none !important;
}

.pase-lista-header {
  gap: 12px;
  padding: 22px 26px !important;
}

.pase-lista-title {
  color: #e0e0e0;
  letter-spacing: 0.01em;
}

.pase-lista-subtitle {
  margin-top: 4px;
  color: rgba(224, 224, 224, 0.72);
  font-size: 0.94rem;
}

.pase-lista-content {
  padding: 24px !important;
}

.search-shell {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.table-shell {
  background: rgba(12, 19, 24, 0.38) !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.14) !important;
  border-radius: 20px !important;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.03), 0 12px 30px rgba(0, 0, 0, 0.2) !important;
}

.table-content {
  padding: 12px !important;
}

.person-name {
  color: #f4f4f4;
  font-weight: 700;
}

.person-meta {
  color: rgba(224, 224, 224, 0.78);
}

.actions-row-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px;
}

.action-trigger {
  display: inline-flex;
}

.fatiga-btn {
  filter: saturate(1.08);
}

::v-deep .search-input .v-input__slot,
::v-deep .search-shell .v-input__slot {
  background: rgba(8, 14, 19, 0.55) !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.18) !important;
  border-radius: 14px !important;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.18) !important;
}

::v-deep .search-input input,
::v-deep .search-input .v-label,
::v-deep .search-input .v-icon {
  color: #e0e0e0 !important;
}

::v-deep .enlace-table {
  background: transparent !important;
}

::v-deep .action-btn,
::v-deep .action-btn.v-btn,
::v-deep .action-btn button {
  margin: 0 !important;
}

::v-deep .action-btn .v-btn,
::v-deep .action-btn.v-btn {
  border-radius: 12px !important;
  transition: transform 0.2s ease, box-shadow 0.2s ease, filter 0.2s ease;
}

::v-deep .action-btn .v-btn:hover,
::v-deep .action-btn.v-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 10px 18px rgba(var(--v-secondary-base-rgb), 0.26) !important;
}

::v-deep .v-data-table__empty-wrapper {
  color: rgba(224, 224, 224, 0.78) !important;
}

::v-deep .v-data-footer {
  color: rgba(224, 224, 224, 0.85) !important;
}

::v-deep .v-data-footer .v-icon {
  color: rgba(224, 224, 224, 0.85) !important;
}

::v-deep .v-data-footer .v-select__selection {
  color: rgba(224, 224, 224, 0.85) !important;
}

@media (max-width: 960px) {
  .pase-lista-header {
    padding: 20px !important;
  }

  .pase-lista-content {
    padding: 18px !important;
  }

  .actions-row-wrapper {
    justify-content: flex-start;
  }
}
</style>
